import axios from "axios";

export const ajax = axios.create({
    baseURL:  process.env.VUE_APP_API_URL,
    // baseURL: 'http://0.0.0.0:8000',
    // baseURL: 'http://164.90.238.48',
    // baseURL: 'https://5-clinic.com',
});
ajax.defaults.headers['Content-Type'] = 'application/json';
ajax.defaults.headers['Accept-Language'] = 'ru,en-US,en';


export const apiUrls = {
    blogSliderUrl: '/api/blog/slider/',
    doctors: '/api/clinic/departments/doctors/',
    news: '/api/blog/news/',
    homepageNews: '/api/blog/news/homepage/',
    offers: '/api/blog/offers/',
    homepageOffers: '/api/blog/offers/homepage/',
    addCommentUrl: (type, slug) => `/api/blog/${type}/${slug}/comment/`,
    newDetail: (type, title) => `/api/blog/${type}/${title}`,
    doctorsDetail: slug => `/api/clinic/doctors/${slug}/`,
    departmentsDropdown: `/api/clinic/departments/dropdown/`,
    departments: (slug) => `/api/clinic/departments/${slug || ""}`,
    schedules: `/api/tables/schedules/`,
    schedulesTable: id => `/api/tables/schedules/${id}/schedule/`,
    priceAndServicesUrl: `/api/tables/price_and_services/`,
    departmentDoctorsUrl: slug => `/api/clinic/departments/${slug}/doctors/`,
    departmentDropDown: `/api/clinic/departments/dropdown/`,
    makeAppointment: `/api/blog/make_appointment/`,
    makeExaminationAppointment: `/api/blog/askQuestion/examination/`,
    makeAnnualAppointment: `/api/blog/askQuestion/annual/`,
    askQuestionToDoctor: doctorSlug => `api/blog/askQuestion/toDoctor/${doctorSlug}/`,
    sendFeedbackToDoctor: doctorSlug => `api/blog/askQuestion/feedback/${doctorSlug}/`,
    specialPrograms: `/api/blog/specialPrograms/`,
};
